<template>
  <TableLayout :permissions="['business:mqttlog:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="编码" prop="id">
        <el-input v-model="searchForm.id" placeholder="请输入编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="创建时间" prop="createDate">
        <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
      </el-form-item>
      <el-form-item label="创建人" prop="creator">
        <el-input v-model="searchForm.creator" placeholder="请输入创建人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="编辑时间" prop="editDate">
        <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入编辑时间" @change="search"/>
      </el-form-item>
      <el-form-item label="编辑人" prop="editor">
        <el-input v-model="searchForm.editor" placeholder="请输入编辑人" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="是否已删除 0未删除 1已删除" prop="isdeleted">
        <el-input v-model="searchForm.isdeleted" placeholder="请输入是否已删除 0未删除 1已删除" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="info">
        <el-input v-model="searchForm.info" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="类型 0订阅 1发布" prop="type">
        <el-input v-model="searchForm.type" placeholder="请输入类型 0订阅 1发布" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="客户端编码" prop="clientid">
        <el-input v-model="searchForm.clientid" placeholder="请输入客户端编码" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="主题" prop="topic">
        <el-input v-model="searchForm.topic" placeholder="请输入主题" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="消息内容" prop="msg">
        <el-input v-model="searchForm.msg" placeholder="请输入消息内容" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="结果 0成功 1失败" prop="result">
        <el-input v-model="searchForm.result" placeholder="请输入结果 0成功 1失败" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:mqttlog:create']">
        <li><el-button type="primary" @click="$refs.operaMqttLogWindow.open('新建系统行为操作记录表')" icon="el-icon-plus" v-permissions="['business:mqttlog:create']">新建</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
      >
        <el-table-column prop="id" label="编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="编辑时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="编辑人" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否已删除 0未删除 1已删除" min-width="100px"></el-table-column>
        <el-table-column prop="info" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0订阅 1发布" min-width="100px"></el-table-column>
        <el-table-column prop="clientid" label="客户端编码" min-width="100px"></el-table-column>
        <el-table-column prop="topic" label="主题" min-width="100px"></el-table-column>
        <el-table-column prop="msg" label="消息内容" min-width="100px"></el-table-column>
        <el-table-column prop="result" label="结果 0成功 1失败" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:mqttlog:update', 'business:mqttlog:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaMqttLogWindow.open('编辑系统行为操作记录表', row)" icon="el-icon-edit" v-permissions="['business:mqttlog:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:mqttlog:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaMqttLogWindow ref="operaMqttLogWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaMqttLogWindow from '@/components/business/OperaMqttLogWindow'
export default {
  name: 'MqttLog',
  extends: BaseTable,
  components: { TableLayout, Pagination, OperaMqttLogWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        createDate: '',
        creator: '',
        editDate: '',
        editor: '',
        isdeleted: '',
        info: '',
        type: '',
        clientid: '',
        topic: '',
        msg: '',
        result: ''
      }
    }
  },
  created () {
    this.config({
      module: '系统行为操作记录表',
      api: '/business/mqttLog',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
